__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/00fdd6b/_next/";